import { SelectionItem } from '@utils'
import { create } from 'zustand'
import { useLanguage } from '../context/LanguageContext'

const relationshipStatuses: SelectionItem[] = [
  { id: 'growing', name: 'relationshipStatus.growing', color: '#7DB527', icon: 'croissance' },
  { id: 'stable', name: 'relationshipStatus.stable', color: '#2E78B8', icon: 'stable' },
  { id: 'to_reconnect', name: 'relationshipStatus.to_reconnect', color: '#FFBB00', icon: 'recontacter' },
  { id: 'fluctuating', name: 'relationshipStatus.fluctuating', color: '#FC7B2B', icon: 'fluctuant' },
  { id: 'declining', name: 'relationshipStatus.declining', color: '#E62D2C', icon: 'decroissance' },
  { id: 'ended', name: 'relationshipStatus.ended', color: '#232323', icon: 'termine' },
]

interface RelationshipStatusStore {
  statuses: SelectionItem[]
  getById: (id: string) => SelectionItem | undefined
}

export const useRelationshipStatusStore = create<RelationshipStatusStore>((set, get) => ({
  statuses: relationshipStatuses,
  getById: (id) => get().statuses.find(s => s.id === id),
}))

export const useTranslatedRelationshipStatusStore = () => {
  const { t } = useLanguage()
  const store = useRelationshipStatusStore()

  const translate = (item: SelectionItem): SelectionItem => ({ ...item, name: t(item.name) })

  return {
    statuses: store.statuses.map(translate),
    getById: (id: string) => {
      const item = store.getById(id)
      return item ? translate(item) : undefined
    },
  }
}
